import React, { FC, useCallback, useState } from 'react'
import NonFlexingContainer from '@sport1/news-styleguide/NonFlexingContainer'
import { useTranslation } from 'react-i18next'
import UniversalProvider, { ThemeTypes } from '@sport1/news-styleguide/UniversalProvider'
import { usePollLoader } from '../hooks/usePollLoader'
import { useQuery } from '../utils/useQuery'
import { usePublishFrameEvent } from '../providers/ParentFrameProvider/ParentFrameProvider'
import { errorClosePollab } from '../providers/ParentFrameProvider/parentFrameEvents'
import AppMaintenance from '../AppMaintenance'
import FullSplashScreen from './Shared/SplashScreen'
import PollScreen from './Screens/PollScreen/PollScreen'

const PollContent: FC = () => {
    const { t } = useTranslation()
    const publish = usePublishFrameEvent()
    const [captureText, setCapture] = useState(t('loading') as string)

    const queries = useQuery()
    const pollID = queries.get('pollID') as string
    const themeName = queries.get('themeName') as ThemeTypes | null

    const fallback = useCallback(() => {
        setCapture(t('loading-error') as string)
        publish(errorClosePollab())
    }, [publish, t])
    const [isLoaded, poll] = usePollLoader(pollID, fallback)

    return (
        <UniversalProvider themeName={themeName || 'webLight'}>
            <AppMaintenance>
                {isLoaded ? (
                    <NonFlexingContainer marginX={4} marginY={4}>
                        <PollScreen poll={poll} />
                    </NonFlexingContainer>
                ) : (
                    <FullSplashScreen text={captureText} />
                )}
            </AppMaintenance>
        </UniversalProvider>
    )
}

export default PollContent
